<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="Reporte Equipos Por Cliente">
        <ReportECli />
      </el-tab-pane>
      <el-tab-pane label="Reporte GPS Por Cliente Plataforma Traccar">
        <ReportgpsPTracca />
      </el-tab-pane>
      <el-tab-pane label="Reporte Terminales Por Cliente">
        <ReportTCliet />
      </el-tab-pane>
      <el-tab-pane label="Reporte Cantidad Terminales">
        <ReportTAmountT />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ReportECli from "@/views/modules/sales/reports/ReportDevicesByClients";
import ReportgpsPTracca from "@/views/modules/technical_support/reports/TraccarGpsReport.vue";
import ReportTCliet from "@/components/reports/ReportTerminals";
import ReportTAmountT from "@/components/reports/ReportesCantidadTerminales";
export default {
  name: "EquipReport",
  components: {
    ReportECli,
    ReportgpsPTracca,
    ReportTCliet,
    ReportTAmountT
  }
};
</script>

<style></style>
